import React, { useMemo } from "react";
import { ArrowRightIcon, CheckIcon, CreditCardIcon, FileTextIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { ProductMockup } from "./ProductMockup";
import { offerIncludes } from "../data/landing";
import { productBrief } from "../data/productBrief";
import { getCheckoutUrl } from "../utils/checkout";
export function OfferSection() {
  const checkoutUrl = useMemo(() => getCheckoutUrl(), []);
  const openLicenseFaq = () => {
    const item = document.getElementById("faq-license");
    if (item instanceof HTMLDetailsElement) item.open = true;
  };
  return <section className="section offer-section" id="offer-details" aria-labelledby="offer-heading" data-id="element-69" data-mp="rdmwbmovc7vq">
      <div className="shell" data-id="element-70" data-mp="wby9o7edh0ip">
        <div className="section-intro" data-id="element-71" data-mp="wc80fx78rbpg">
          <p className="eyebrow" data-id="element-72" data-mp="2t5jbd6a8vzv9">THE PLANNING IS ALREADY DONE</p>
          <h2 id="offer-heading" data-id="element-73" data-mp="2t7dwaklinrzc">
            Ten sales training sessions.
            <br data-id="element-74" data-mp="2y55o7em5ve3j" />
            <span data-id="element-75" data-mp="2y4mfmoiei226">Planned from opening to follow-up.</span>
          </h2>
        </div>
        <div className="offer-grid" data-id="element-76" data-mp="12p36z8q07qqa">
          <div className="offer-contents" data-id="element-77" data-mp="xws6a3nfw0wo">
            <p className="eyebrow" data-id="element-78" data-mp="xvqt9tmv54cb">THE COMPLETE DIGITAL KIT</p>
            <h3 data-id="element-79" data-mp="sxflrpk1j5x9">{productBrief.brand}</h3>
            <p data-id="element-80" data-mp="syiaprxsyyaj">
              The agendas, facilitator wording, role cards, examples and feedback sheets are already
              written. You get two manual volumes covering all ten sessions, printable participant
              materials and five bonuses to organize the practice around them.
            </p>
            <h4 data-id="element-81" data-mp="1gnt2ijx6dicj">Your ready-to-run training plan includes</h4>
            <ul className="check-list" data-id="element-82" data-mp="1cl6gx0r3ktns">
              {offerIncludes.map(item => <li key={item} data-id="element-83" data-mp="17mv7gr4psl63">
                  <CheckIcon size={18} aria-hidden="true" data-id="element-84" data-mp="17ltlhrm5ue9l" />
                  {item}
                </li>)}
            </ul>
            <h4 data-id="element-85" data-mp="14gb3iql63up">All five bonuses are included</h4>
            <ul className="bonus-checks" data-id="element-86" data-mp="3sckjyxhy3uvm">
              {productBrief.bonuses.map(bonus => <li key={bonus.number} data-id="element-87" data-mp="3ttpxu95yrlcp">
                  <CheckIcon size={16} aria-hidden="true" data-id="element-88" data-mp="3trwscx73776a" />
                  {bonus.title}
                </li>)}
            </ul>
          </div>

          <div className="price-card" data-id="element-89" data-mp="3ks9ps82mfvbn">
            <ProductMockup data-id="element-90" data-mp="3kve25sq8pxde" />
            <p className="price-caption" data-id="element-91" data-mp="3oumtkqxt5j5s">2 VOLUMES · 10 WORKSHOPS + 5 BONUSES</p>
            <p className="offer-price" data-id="element-92" data-mp="3owr9y8cw8amy">
              <span data-id="element-93" data-mp="3b388mekcb7w3">${productBrief.price.amountUsd}</span> USD
            </p>
            <p className="payment-note" data-id="element-94" data-mp="3ftyh40o2bqv0">One-time payment. No subscription.</p>
            <CtaButton href={checkoutUrl} data-id="element-95" data-mp="3fw1gvcf0oycx">
              Get my complete training plan <ArrowRightIcon size={18} aria-hidden="true" data-id="element-96" data-mp="316wtlgtd83xy" />
            </CtaButton>
            <div className="delivery-details" data-id="element-97" data-mp="3656sa1eatmob">
              <p data-id="element-98" data-mp="2s4nm6zte8qos">
                <CreditCardIcon size={17} aria-hidden="true" data-id="element-99" data-mp="2s444nk7no4ba" />
                Continue to the Impul store checkout
              </p>
              <p data-id="element-100" data-mp="2x2fg1zdlmmvm">
                <FileTextIcon size={17} aria-hidden="true" data-id="element-101" data-mp="2x2xgl87ann9c" />
                English PDFs + printable participant pages
              </p>
            </div>
            <p className="format-note" data-id="element-102" data-mp="28jnf6twbkf3c">
              {productBrief.status}
              <br data-id="element-103" data-mp="2min0psojcdva" />
              Internal-team use. No video, slides, editable templates, software, certification or
              resale rights.
            </p>
            <a className="license-link" href="#faq-license" onClick={openLicenseFaq} data-id="element-104" data-mp="2ifqfdu7m23nn">
              Read format and license FAQs
            </a>
          </div>
        </div>
      </div>
    </section>;
}